var modules_51430e0a = {"item":"MenuItem_module_item__f97e774e","imgWrapper":"MenuItem_module_imgWrapper__f97e774e","img":"MenuItem_module_img__f97e774e","dark":"MenuItem_module_dark__f97e774e"};
import "../../../assets/esm/components/MenuItem/src/MenuItem~DtGBRGRf.css";

export { modules_51430e0a as default };
//# sourceMappingURL=MenuItem.module.less.js.map
